/** Months of check-ins the RM Margin by Check In chart covers by default, from the start of the current quarter. */
const CHECK_IN_MONTHS = 18;

/** Default check-in window for a Sydney as-of date (YYYY-MM-DD): the current quarter's first day through the day
 * before the same date CHECK_IN_MONTHS later. The Tableau workbook saved a fixed 2024-11-01 to 2026-03-31 window,
 * which no longer contains any current stays and leaves the chart at zero. */
export function defaultCheckInWindow(asOf: string): { from: string; to: string } {
  const [year, month] = asOf.split('-').map(Number);
  const quarterMonth = Math.floor((month - 1) / 3) * 3;
  const start = new Date(Date.UTC(year, quarterMonth, 1));
  const end = new Date(Date.UTC(year, quarterMonth + CHECK_IN_MONTHS, 0));
  return { from: start.toISOString().slice(0, 10), to: end.toISOString().slice(0, 10) };
}
